import React, { Component } from "react";
import { getUserRecommendation, page } from "../../Model/Content"; //Include Home
import { Banner } from "../banner/Banner"; //Include Banner
import { Special } from "../special/Special"; //Include Special
import Search from "../search/Search";
import {
  getSignUp,
  CheckUser,
  userprofile,
  getGeoInfo,
} from "../../Model/Users";
import Notification from "../Notification/Notification";
import { Link } from "react-router-dom";
import { Docubytes } from "../Docubytes/Docubytes";
import { StartExploring } from "../startExploring/startExploring";
import { Layout1 } from "../Layout1/Layout1";
import { Layout2 } from "../Layout2/Layout2";
import { Layout3 } from "../Layout3/Layout3";
import { Layout9 } from "../Layout9/Layout9";
import { Layout5 } from "../Layout5/Layout5";
import { Layout7 } from "../Layout7/Layout7";
import { Layout8 } from "../Layout8/Layout8";
import { Layout10 } from "../Layout10/Layout10";
import { Layout11 } from "../Layout11/Layout11";
import { Layout12 } from "../Layout12/Layout12";
import { Layout13 } from "../Layout13/Layout13";
import { Layout14 } from "../Layout14/Layout14";
import { Layout15 } from "../Layout15/Layout15";
import { Layout22 } from "../Layout22/Layout22";
import { Layout27 } from "../Layout27/Layout27";
import { Layout30 } from "../Layout30/Layout30";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { Childlock } from "../Childlock/Childlock";
import { Continue } from "../Continue-watching/Continue";
import { Metadata } from "../Metadata/Metadata";
import Header from "../common/Header";
import Allbays from "../Allbays/Allbays";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Footerdesk } from "../../components/FooterDesk/Footerdesk";
import { ToastContainer } from "react-toastify";
import PageNotFound from "../../components/PageNotFound/PageNotFound";
import BarLoader from "react-spinners/BarLoader";
import { Genrelist } from "../../Model/Content";
import {
  SVGIcons,
  ImgIcons,
  VirsionCheck,
  withRouter,
  Appsflyer,
} from "../../Helpers/Common";
import { Profilemenu } from "../Profile_menu/Profilemenu";
import Notifcationdesk from "../../components/Notifcationdesk/Notifcationdesk";
import { isMobile, isTablet } from "react-device-detect";
import Maintenance from "../signup/Maintenance";
import InfiniteScroll from "react-infinite-scroll-component";
// import InfiniteScroll from "../home/InfiniteScroll"
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pageData: [],
      countryCode: '',
      DataisLoaded: false,
      VirsionCheckData: "",
      VirsionCheckDataloaded: false,
      SearchClick: false,
      userData: false,
      NotificationClick: false,
      showallbays: false,
      maintenance: true,
      isLive: true,
      goldenDIcon: "",
      silverDIcon: "",
      bgGoldenDesktop: "",
      bgGoldenMobile: "",
      bgSilverDesktop: "",
      bgSilverMobile: "",
      goldenDOriginalIcon: "",
      originalLogo: "",
      pageNo: 0,
      pageSize: 5,
      isFetching: false,
      recommendEngine: [],
      userchecked: false,
    };
  }

  componentDidMount() {
    getGeoInfo().then((res) => {
      let data = {
        seesionID: localStorage.getItem("session_id"),
        userID: localStorage.getItem("userID")
      }
      VirsionCheck().then((vcheckres) => {
        if (vcheckres.data) {
          this.setState((prev) => ({
            isLive: JSON.parse(vcheckres.data).data.is_live_tv,
            goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
            silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
            bgGoldenDesktop: JSON.parse(vcheckres.data).data["bg_golden_layout"],
            bgGoldenMobile: JSON.parse(vcheckres.data).data["bg_golden_layout_mobile"],
            bgSilverDesktop: JSON.parse(vcheckres.data).data["bg_silver_layout"],
            bgSilverMobile: JSON.parse(vcheckres.data).data["bg_silver_layout_mobile"],
            goldenDOriginalIcon: JSON.parse(vcheckres.data).data["d_original"],
            originalLogo: JSON.parse(vcheckres.data).data["docubay_originals_url"]
          }));
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
          });
        }
        return true
      });

      userprofile(data).then((userDatares) => {
        var parseUserdata = JSON.parse(userDatares?.data?.message);
        if (userDatares.data.message == "session_expired" || parseUserdata.errorcode == 1008) {
          this.props.navigate("/createaccount");
        } else {
          var userDatares = JSON.parse(userDatares.data.message);
          this.setState({
            userData: userDatares.user_data,
          });
        }
        this.fetchData();
      });
    });
  }

  fetchData() {
    // this.setState({ isFetching: true });
    var isChildData = localStorage.getItem("is_child_local_storage") == "true" ? true : false;
    const { countryCode, userData, pageNo, pageSize } = this.state;
    page("default", countryCode, isChildData, pageNo, pageSize).then((response) => {
      if (response.data.success == false) {
        this.props.navigate("/createaccount");
      }
      try {
        this.setState((prev) => ({
          items: response,
          DataisLoaded: true,
          pageData: [...prev.pageData, ...this.getparseData(response)]
        }));
        if (this.state.pageNo < 25) {
          this.setState((prevState) => ({ pageNo: prevState.pageNo + 5 }), () => {
            this.fetchData();
          });
        }
      } catch (error) {
        this.props.navigate("/createaccount");
        console.error("Error parsing JSON data:", error);
        // Handle the error gracefully
      }
    });
    // if (pageNo == 0) {
    //   getUserRecommendation("default", countryCode, userData, pageNo, pageSize).then((userContentsResp) => {
    //     if (userContentsResp.data.home) {
    //       const recommendDataResp = userContentsResp.data.home;// JSON.parse(JSON.parse(userContentsResp.data.home));
    //       this.setState({
    //         recommendEngine: recommendDataResp['contents'],
    //       });
    //     } else {
    //       // console.error("userContentsResp.home is undefined or null.");
    //     }
    //   });
    // }
  }

  getparseData(response) {
    const data = response.data.home //  JSON.parse(JSON.parse(response.data.home));
    return data?.pageData?.lists;
  }

  // fetchMoreData = () => {
  //   if (this.state.pageNo < 25) {
  //     this.setState((prevState) => ({ pageNo: prevState.pageNo + 5, isFetching: true }), () => {
  //       this.fetchData();
  //     });
  //   }
  // };

  search() {
    this.setState({
      SearchClick: true,
    });
  }

  SearchClose() {
    this.setState({
      SearchClick: false,
    });
  }

  Notification() {
    this.setState({
      NotificationClick: true,
    });
  }

  Showallbays() {
    this.setState({
      showallbays: true,
    });
  }

  ShowallbaysClose() {
    this.setState({
      showallbays: false,
    });
  }

  NotificationClose() {
    this.setState({
      NotificationClick: false,
    });
  }

  render() {
    const { items, DataisLoaded, VirsionCheckData, VirsionCheckDataloaded, isFetching } = this.state;

    if (DataisLoaded === false || this.state.VirsionCheckDataloaded === false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    }

    //Search Tab Open

    if (this.state.SearchClick === true) {
      return (
        <Search
          functions={this}
          closefrom="true"
          goldenIcon={this.state.goldenDIcon}
          silverIcon={this.state.silverDIcon}
        />
      );
    }

    // Notification Tab Open
    if (this.state.NotificationClick === true) {
      return <Notification functions={this} />;
    }

    // HomepageData = JSON.parse(JSON.parse(HomepageData));
    const HomepageData = items.data.home //JSON.parse(JSON.parse(items.data.home));
    if (HomepageData.pageData) {
      var Baysdata = HomepageData.bayData;
    } else {
      return <PageNotFound />;
    }
    // if (Baysdata.length == 0) {
    //   Genrelist().then((GenreData) => {
    //     if (GenreData.data) {
    //       Baysdata = GenreData.data;
    //     }
    //   })
    // }

    // document.addEventListener("scroll", () => {
    //   const header = document.querySelector("header");
    //   if (header) {
    //     if (window.scrollY > 10) {
    //       header.classList.add("head-hide");
    //     } else {
    //       header.classList.remove("head-hide");
    //     }
    //   }
    // });

    let scrollThreshold;

    if (isMobile) {
      scrollThreshold = 0.1; // Adjust for mobile
    } else if (isTablet) {
      scrollThreshold = 0; // Adjust for tablet
    } else {
      scrollThreshold = 0.1; // Default threshold for desktop
    }

    return (
      <>
        {!this.state.maintenance ? (
          <Maintenance />
        ) : (
          <>
            <Metadata page="HOME" />
            <motion.div
              className=""
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.4 }}
              key="1"
            >
              <div className="banner-overlay dD-block"></div>
              <Header
                userprofile={this.state.userData}
                bayData={Baysdata}
                page={"home"}
                classdata={this}
              />
              {/* <InfiniteScroll
                // fetchMore={this.fetchMoreData}
                // loadingComponent={<div>Loading...</div>}
                // isFetching={isFetching}
                dataLength={this.state.pageData.length}
                next={this.fetchMoreData}
                hasMore={true}
                style={{ overflow: "none" }}
                scrollThreshold={0}
              > */}
              <div>
                {this.state.pageData.map((data, index) => {
                  if (data.section_layout == "Layout 0") {
                    return (
                      <Banner
                        BannerDatas={data.contents}
                        goldenIcon={this.state.goldenDIcon}
                        silverIcon={this.state.silverDIcon}
                        goldenOriginalIcon={this.state.goldenDOriginalIcon}
                        fun={this}
                        key={data.section_layout}
                      />
                    );
                  }
                  // else if (data.section_layout == "Layout 20") {
                  //   return (
                  //     <Docubytes
                  //       DocubytesPro={data.contents}
                  //       key={index}
                  //       key="docubytes"
                  //     />
                  //   );
                  // }
                  else if (data.section_layout == "Layout 1") {
                    return (
                      <div className="latestBay">
                        <Layout1
                          Layout1={data.contents}
                          key={index}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 2") {
                    return (
                      //SpecialBay
                      <div className="latestBay">
                        <Layout2
                          Layout1={data.contents}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          key={index}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 3") {
                    return (
                      //TrendingBay
                      <div className="latestBay">
                        <Layout3
                          Layout1={data.contents}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          key={index}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 4") {
                    return (
                      //Continue Watching
                      <div className="latestBay">
                        <Continue
                          Layout1={data.contents}
                          key={index}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 5") {
                    //Free bay
                    return (
                      <div className="latestBay">
                        <Layout5
                          Layout1={data.contents}
                          key={index}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 7") {
                    return (
                      <div className="latestBay">
                        <Layout7
                          Layout1={data.contents}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          key={index}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 8") {
                    return (
                      //Most WatchedBay
                      <div className="latestBay">
                        <Layout8
                          Layout1={data.contents}
                          key={index}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 9") {
                    //AwardWinning
                    return (
                      <div className="latestBay">
                        <Layout9
                          Layout1={data.contents}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          key={index}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 10") {
                    return (
                      //TechBay
                      <div className="latestBay">
                        <Layout10
                          Layout1={data}
                          key={index}
                          title={data}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 11") {
                    return (
                      <div className="latestBay">
                        <Layout11
                          Layout1={data.contents}
                          key={index}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 12") {
                    //Docubuster of the month
                    return (
                      <div className="latestBay">
                        <Layout12
                          Layout1={data.contents}
                          key={index}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          goldenOriginalIcon={this.state.goldenDOriginalIcon}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 13") {
                    return (
                      //AdventureBay
                      <div className="latestBay">
                        <Layout13
                          Layout1={data.contents}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          key={index}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 14") {
                    return (
                      //SurpriseMe
                      <div className="latestBay">
                        <Layout14
                          Layout1={data.contents}
                          key={index}
                          goldenIcon={this.state.goldenDIcon}
                          silverIcon={this.state.silverDIcon}
                          title={data}
                        />
                      </div>
                    );
                  } else if (data.section_layout == "Layout 27") {
                    return (
                      <div className="latestBay">
                        {data.contents ? (
                          <Layout27
                            Layout1={data.contents}
                            key={index}
                            title={data}
                            bgGoldenDesk={this.state.bgGoldenDesktop}
                            originalLogo={this.state.originalLogo}
                            bgGoldenMob={this.state.bgGoldenMobile}
                          />
                        ) : null}
                      </div>
                    );
                  } else if (data.section_layout == "Layout 28") {
                    return (

                      <div className="latestBay">
                        {data.contents ? (
                          <Layout27
                            Layout1={data.contents}
                            key={index}
                            title={data}
                            bgSilverDesk={this.state.bgSilverDesktop}
                            bgSilverMob={this.state.bgSilverMobile}
                          />
                        ) : null}
                      </div>
                    );
                  }
                  // else if (data.section_layout == "Layout 29") {
                  //   return (
                  //     <div className="latestBay">
                  //       {data.contents ? (
                  //         <Layout27
                  //           Layout1={data.contents}
                  //           key={index}
                  //           title={data}
                  //           bgGoldenDesk={this.state.bgGoldenDesktop}
                  //           originalLogo={this.state.originalLogo}
                  //           bgGoldenMob={this.state.bgGoldenMobile}
                  //         />
                  //       ) : null}
                  //     </div>
                  //   );
                  // }
                  else if (data.section_layout == "Layout 30") {
                    return (
                      <div className="latestBay">
                        {data.contents ? (
                          <Layout30
                            Layout1={data.contents}
                            key={index}
                            goldenIcon={this.state.goldenDIcon}
                            silverIcon={this.state.silverDIcon}
                            title={data}
                            bgGoldenDesk={this.state.bgGoldenDesktop}
                            originalLogo={this.state.originalLogo}
                            bgGoldenMob={this.state.bgGoldenMobile}
                          />
                        ) : null}
                      </div>
                    );
                  }
                  // else if (data.section_layout == "Layout 21") {
                  //   return (
                  //     //Start Exploring
                  //     <div className="latestBay">
                  //       <Layout22 topics={data.contents} key={index} title={data} />
                  //     </div>
                  //   );
                  // }
                  else {
                  }
                })}
              </div>
              {/* </InfiniteScroll> */}
              <ToastContainer
                position="bottom-center"
                autoClose={4000}
                hideProgressBar={true}
                closeButton={false}
                theme="light"
              />
              {this.state.showallbays === true ? (
                <Allbays functions={Baysdata} />
              ) : null}
              {this.state.userData != false ? (
                <Childlock data={this.state.userData} />
              ) : null}
              <div className="pb-m dD-none"></div>
              {window.innerWidth > 768 ? <Footerdesk /> : null}
              {/* {!isMobile ? null : <Mobilemenu active="1" />} */}
              <Mobilemenu active="1" isLive={this.state.isLive} />
            </motion.div>
          </>
        )}
      </>
    );
  }
}
export default withRouter(Home);
